/* Olaben cart helpers (classic script, not a module, so Shopify's asset
   pipeline won't rewrite it).

   1) AUTO-OPEN: open the cart drawer after any add-to-cart, including the
      collection-card quick add. Subscribes to Dawn's cartUpdate pub/sub event
      and opens the drawer if it isn't already open. Safe/idempotent: if the
      theme's own renderContents() already opened the drawer, this is a no-op.

   2) BADGE RECONCILE: keep the header cart-count bubble honest. The header
      badge and the drawer are independent server-rendered snapshots of the
      cart. They only stay in sync when a shopper edits quantity through the
      drawer's own controls. Anything that changes the cart out-of-band --
      Shopify Shop cart sync on page load, a second browser tab, or a line
      auto-removed at checkout -- leaves the header badge stale (e.g. it shows
      3 while the cart actually holds 1). This re-reads /cart.js (the source of
      truth) and repaints .cart-count-bubble to match. It only touches the
      little count bubble, never the custom .hp02 cart icon. */
(function () {
  'use strict';

  /* ---------- 1. Auto-open drawer ---------- */
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
      drawer.open();
    }
  }

  /* ---------- 2. Badge reconcile ---------- */
  var reconciling = false;
  var pending = false;

  function paintBubble(count) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var bubble = link.querySelector('.cart-count-bubble');

    // Empty cart -> no bubble at all (matches the theme's {% if cart != empty %}).
    if (!count || count < 1) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      link.appendChild(bubble);
    }

    // Visible number, only when < 100 (matches the theme Liquid).
    var numSpan = bubble.querySelector('span[aria-hidden="true"]');
    if (count < 100) {
      if (!numSpan) {
        numSpan = document.createElement('span');
        numSpan.setAttribute('aria-hidden', 'true');
        bubble.insertBefore(numSpan, bubble.firstChild);
      }
      if (numSpan.textContent !== String(count)) numSpan.textContent = String(count);
    } else if (numSpan) {
      numSpan.remove();
    }

    // Screen-reader count. Keep the existing locale wording if present and just
    // swap the number; otherwise fall back to a plain English label.
    var hidden = bubble.querySelector('.visually-hidden');
    if (!hidden) {
      hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      bubble.appendChild(hidden);
    }
    if (/\d/.test(hidden.textContent)) {
      hidden.textContent = hidden.textContent.replace(/\d[\d.,]*/, String(count));
    } else {
      hidden.textContent = count + ' item' + (count === 1 ? '' : 's');
    }
  }

  function reconcileBadge() {
    if (reconciling) { pending = true; return; }
    reconciling = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintBubble(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
      })
      .catch(function () { /* network error: leave the badge as-is */ })
      .then(function () {
        reconciling = false;
        if (pending) { pending = false; setTimeout(reconcileBadge, 150); }
      });
  }

  /* ---------- wiring ---------- */
  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(openDrawer, 80);      // let the theme render the drawer first
      setTimeout(reconcileBadge, 120); // then correct the badge from the source of truth
    });
    return true;
  }

  // Reconcile on load, then again shortly after: Shop cart sync reconciles the
  // cart asynchronously after page load, so a single pass can run too early.
  function initReconcile() {
    reconcileBadge();
    setTimeout(reconcileBadge, 1500);
    setTimeout(reconcileBadge, 3500);
  }

  // Catch cross-tab cart edits and returning to the tab / bfcache restores.
  window.addEventListener('pageshow', reconcileBadge);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') reconcileBadge();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (!bind()) setTimeout(bind, 500);
      initReconcile();
    });
  } else {
    if (!bind()) setTimeout(bind, 500);
    initReconcile();
  }
})();
